import React from "react";

// Image imports (ensure these exist in src/assets/img)
import sof1 from "../assets/img/sof1.jpg";
import erp1 from "../assets/img/erp1.jpg";
import mobileApp from "../assets/img/mobile-app.jpg";
import property from "../assets/img/property.jpg";
import crm from "../assets/img/CRM.png";
import rfid from "../assets/img/RFID.jpg";
import consult from "../assets/img/consult.jpg";
import quality from "../assets/img/quality.jpg";
import system from "../assets/img/system-implementation.jpg";

const servicesData = [
  {
    title: "Software Solutions",
    desc: "Comprehensive software development services including ERP systems, mobile & web applications, and specialized business solutions.",
    icon: "fas fa-laptop-code",
    img: sof1,
    delay: "100",
  },
  {
    title: "ERP Systems",
    desc: "Integrated ERP solutions with modules for finance, HR, supply chain, inventory, and sales management.",
    icon: "fas fa-database",
    img: erp1,
    delay: "300",
  },
  {
    title: "Mobile & Web Apps",
    desc: "Custom mobile and web application development using modern technologies for responsive solutions.",
    icon: "fas fa-mobile-alt",
    img: mobileApp,
    delay: "500",
  },
  {
    title: "Property Management",
    desc: "Specialized lease and property management software solutions to streamline operations and enhance portfolio management.",
    icon: "fas fa-building",
    img: property,
    delay: "100",
  },
  {
    title: "CRM & Sales Force",
    desc: "Advanced CRM and Sales Force Automation solutions to enhance customer relationships and boost sales performance.",
    icon: "fas fa-chart-line",
    img: crm,
    delay: "300",
  },
  {
    title: "RFID Solutions",
    desc: "Implementation of RFID technology for asset tracking, inventory management, and security applications.",
    icon: "fas fa-wifi",
    img: rfid,
    delay: "500",
  },
  {
    title: "IFRS Consultation",
    desc: "Expert consultation services for IFRS implementation, policy documentation, and compliance management.",
    icon: "fas fa-handshake",
    img: consult,
    delay: "100",
  },
  {
    title: "Quality Management",
    desc: "Comprehensive quality management solutions including QMS and FSMS implementation to ensure operational excellence.",
    icon: "fas fa-check-circle",
    img: quality,
    delay: "300",
  },
  {
    title: "System Implementation",
    desc: "End-to-end system deployment, maintenance, and support services to ensure smooth operations.",
    icon: "fas fa-cogs",
    img: system,
    delay: "500",
  },
];

const Services = () => {
  return (
    <div className="container-fluid service overflow-hidden pt-5" id="services">
      <div className="container py-5">
        {/* Title */}
        <div
          className="section-title text-center mb-5"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="sub-style">
            <h5 className="sub-title" style={{ color: "#A71717" }}>
              What We Offer
            </h5>
          </div>
          <h1 className="display-5 mb-4" style={{ color: "#A71717" }}>
            Comprehensive Software Solutions & Consulting Services
          </h1>
          <p className="mb-0" style={{ color: "#666" }}>
            Empowering businesses with cutting-edge technology solutions and expert consultation services to drive growth and efficiency
          </p>
        </div>

        {/* Service cards */}
        <div className="row g-4">
          {servicesData.map((service, i) => (
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay={service.delay}
              key={i}
            >
              <div className="card h-100 shadow-sm">
                <img
                  src={service.img}
                  className="card-img-top"
                  alt={service.title}
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <div className="card-body text-center">
                  <div className="mb-4">
                    <i className={`${service.icon} fa-3x`} style={{ color: "#A71717" }}></i>
                  </div>
                  <h4 className="card-title" style={{ color: "#A71717" }}>
                    {service.title}
                  </h4>
                  <p className="card-text" style={{ color: "#666" }}>
                    {service.desc}
                  </p>
                  <a
                    href="#"
                    className="btn rounded-pill text-white mt-3"
                    style={{ backgroundColor: "#A71717" }}
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
